import { render, staticRenderFns } from "./UploadClients.vue?vue&type=template&id=7b0f5010&scoped=true&"
import script from "./UploadClients.vue?vue&type=script&lang=js&"
export * from "./UploadClients.vue?vue&type=script&lang=js&"
import style0 from "./UploadClients.vue?vue&type=style&index=0&id=7b0f5010&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0f5010",
  null
  
)

export default component.exports